import { render, staticRenderFns } from "./viewCommonTickets.vue?vue&type=template&id=1cff015d"
import script from "./viewCommonTickets.vue?vue&type=script&lang=js"
export * from "./viewCommonTickets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports